import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settings/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSettingsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public settings: any = {};
    public apiKeyMasked: string = '';
    public newApiKey: string = '';
    public modelOptions: string[] = ['gpt-4o', 'gpt-4o-mini', 'gpt-4-turbo'];
    public testResult: string = '';
    public isTesting: boolean = false;

    public activeTab: string = 'general';
    public llmUsage: any = { rows: [], total: 0, total_cost: 0, total_tokens: 0 };
    public auditLogs: any = { rows: [], total: 0 };
    public llmPage: number = 1;
    public auditPage: number = 1;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        let res = await wiz.call("load");
        if (res.code === 200) {
            this.settings = res.data;
            this.apiKeyMasked = res.data.api_key_masked || '';
        }
    }

    public async switchTab(tab: string) {
        this.activeTab = tab;
        if (tab === 'llm' && this.llmUsage.rows.length === 0) {
            await this.loadLLMUsage();
        }
        if (tab === 'audit' && this.auditLogs.rows.length === 0) {
            await this.loadAuditLogs();
        }
        await this.service.render();
    }

    public async saveApiKey() {
        if (!this.newApiKey) return;
        let res = await wiz.call("save_api_key", { api_key: this.newApiKey });
        if (res.code === 200) {
            await this.service.modal.show({ title: '성공', message: 'API 키가 저장되었습니다.' });
            this.newApiKey = '';
            await this.load();
        } else {
            await this.service.modal.show({ title: '오류', message: res.data?.message || '저장 실패' });
        }
        await this.service.render();
    }

    public async saveModel() {
        let res = await wiz.call("save_model", { model: this.settings.openai_model || 'gpt-4o' });
        if (res.code === 200) {
            await this.service.modal.show({ title: '성공', message: '모델 설정이 저장되었습니다.' });
        }
        await this.service.render();
    }

    public async saveFee() {
        let res = await wiz.call("save_fee", { fee: this.settings.default_monthly_fee || '0' });
        if (res.code === 200) {
            await this.service.modal.show({ title: '성공', message: '월회비 설정이 저장되었습니다.' });
        }
        await this.service.render();
    }

    public async testConnection() {
        this.isTesting = true;
        this.testResult = '테스트 중...';
        await this.service.render();

        let res = await wiz.call("test_connection");
        if (res.code === 200) {
            this.testResult = '✅ 연결 성공: ' + (res.data?.message || '');
        } else {
            this.testResult = '❌ 연결 실패: ' + (res.data?.message || '');
        }
        this.isTesting = false;
        await this.service.render();
    }

    public async loadLLMUsage() {
        let res = await wiz.call("llm_usage", { page: this.llmPage, dump: 20 });
        if (res.code === 200) {
            this.llmUsage = res.data;
        }
        await this.service.render();
    }

    public async loadAuditLogs() {
        let res = await wiz.call("audit_logs", { page: this.auditPage, dump: 30 });
        if (res.code === 200) {
            this.auditLogs = res.data;
        }
        await this.service.render();
    }
}

export default PageSettingsComponent;